export interface BetaMapFboConfig {
    icao: string;
    fbos?: string[];
}

export const BETA_MAP_FBOS_ALLOWED: BetaMapFboConfig[] = [
    { icao: 'KFCM' },
    { icao: 'KCAE' },
    { icao: 'KGEG' },
    { icao: 'KBUR' },
    { icao: 'KNEW' },
    { icao: 'KSAT' },
    { icao: 'KHOU' },
    { icao: 'KBFL' },
    { icao: 'PHKO' },
    { icao: 'KFXE' },
    { icao: 'KOPF' },
    { icao: 'KVNY' },
    { icao: 'KFLL' },
    { icao: 'KAPC' },
    { icao: 'KADS' },
    { icao: 'KCXO' },
    { icao: 'KILM' },
    { icao: 'MBPV' },
    { icao: 'KPTK' },
    { icao: 'KBHM', fbos: ['Million Air BHM'] },
];

export const FLIGHT_WATCH_CONSTANTS = {
    MAX_DIMENSIONS_PX: 800,
    MIN_DIMENSIONS_PX: 0,
    DEFAULT_MAP_WIDTH: 'calc(100% - 400px)',
} as const;

